<!-- Loading spinner -->
<div *ngIf="loading" class="loading-overlay">
  <div class="loading-overlay" *ngIf="!loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>
</div>

<router-outlet></router-outlet>